import React from 'react';

class CheckBoxInput extends React.Component {
  render() {
    const {
      value,
      ...rest
    } = this.props;
    return (
      <label className="toggle-label">
        <input
          type="checkbox"
          checked={value}
          {...rest}
        />
        <span className="back">
          <span className="toggle" />
          <span className="label on">ON</span>
          <span className="label off">OFF</span>
        </span>
      </label>
    );
  }
}

export default CheckBoxInput;



// WEBPACK FOOTER //
// ./foody/src/components/Common/CheckBoxInput.jsx